(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

(function ($) {
  tinymce.create('tinymce.plugins.AirstreamButtons', {
    /**
     * Initializes the plugin, this will be executed after the plugin has been created.
     * This call is done before the editor instance has finished it's initialization so use the onInit event
     * of the editor instance to intercept that event.
     *
     * @param {tinymce.Editor} ed Editor instance that the plugin is initialized in.
     * @param {string} url Absolute URL to where the plugin is located.
     */
    init: function init(ed, url) {
      function monitorNodeChange() {
        var btn = this;
        ed.on('NodeChange', function (e) {
          btn.disabled(e.element.nodeName.toLowerCase() == 'img');
        });
      }
      function hide_monitorNodeChange() {
        var btn = this;
        ed.on('NodeChange', function (e) {
          var selectedElement = e.element.nodeName.toLowerCase();
          btn.disabled(selectedElement == 'body');
        });
      }
      function twitter_monitorNodeChange() {
        var btn = this;
        ed.on('NodeChange', function (e) {
          var formatMatch = ed.formatter.match('blockquote');
          var selectedElement = $(ed.selection.getNode());
          btn.disabled(!formatMatch);
        });
      }

      ed.addButton('air_brightcove_embed', {
        text: 'Brightcove Embed',
        icon: false,
        onclick: function onclick() {
          tinyMCE.activeEditor.execCommand('air_do_brightcove_embed');
        }
      });
      ed.addButton('h_links', {
        text: 'Links',
        icon: false,
        type: 'menubutton',
        menu: [{
          text: 'Default Link',
          onclick: function onclick() {
            tinyMCE.activeEditor.execCommand('h_do_link');
          }
        }, {
          text: 'Force Download',
          onpostrender: monitorNodeChange,
          onclick: function onclick() {
            tinyMCE.activeEditor.execCommand('h_do_download');
          }
        }, {
          text: 'Modal Link',
          menu: [{
            text: 'Image Modal',
            onclick: function onclick() {
              tinyMCE.activeEditor.execCommand('h_do_modal_image');
            }
          }, {
            text: 'Video Modal',
            onclick: function onclick() {
              tinyMCE.activeEditor.execCommand('h_do_modal_video');
            }
          }]
        }]
      });
      ed.addButton('h_quote', {
        title: 'Quotes',
        icon: 'icon fa-quote-left',
        disabledStateSelector: 'a, img',
        onclick: function onclick() {
          tinyMCE.activeEditor.execCommand('h_do_quote');
        }
      });
      ed.addButton('h_twitter_quote', {
        title: 'Tweet Quote',
        icon: 'icon fa-twitter',
        onpostrender: twitter_monitorNodeChange,
        onclick: function onclick() {
          tinyMCE.activeEditor.execCommand('h_do_twitter_quote');
        }
      });
      ed.addButton('h_columns', {
        title: 'Columns',
        icon: 'icon fa-columns',
        onclick: function onclick() {
          tinyMCE.activeEditor.execCommand('h_do_columns');
        }
      });
      ed.addButton('air_hide_element', {
        title: 'Hide Element',
        text: 'Hide Element',
        onpostrender: hide_monitorNodeChange,
        onclick: function onclick() {
          tinyMCE.activeEditor.execCommand('air_do_hide_element');
        }
      });
      ed.addButton('air_share', {
        title: 'Share Links',
        icon: 'icon fa-share-alt',
        onclick: function onclick() {
          tinyMCE.activeEditor.execCommand('air_do_share');
        }
      });
      ed.addCommand('air_do_brightcove_embed', function () {
        var selected_node = ed.selection.getNode();
        ed.windowManager.open({
          title: 'Brightcove Embed',
          body: [{
            type: 'container',
            name: 'brightcove_embed_note',
            html: '<span style="font-size:14px;">Insert an advanced Brightcove embed by supplying the video ID, e.g. 5706146519001.</span>'
          }, {
            type: 'textbox',
            name: 'video_id',
            text: 'Video ID'
          }],
          onSubmit: function onSubmit(e) {
            ed.execCommand('mceInsertContent', 0, '[brightcove_embed id="' + e.data.video_id + '"]');
          }
        });
      });
      ed.addCommand('air_do_hide_element', function () {
        var selected_node = ed.selection.getNode();
        ed.windowManager.open({
          title: 'Hide Element',
          body: [{
            type: 'container',
            name: 'hide_element_note',
            html: '<span style="font-size:14px;">Select when the element should be hidden.</span>'
          }, {
            type: 'checkbox',
            name: 'mobile',
            text: 'Mobile'
          }, {
            type: 'checkbox',
            name: 'tablet',
            text: 'Tablet'
          }, {
            type: 'checkbox',
            name: 'desktop',
            text: 'Desktop'
          }],
          onSubmit: function onSubmit(e) {
            var mobile = '',
                tablet = '',
                desktop = '';
            if (e.data.mobile) {
              mobile = ' d-sm-block';
            }
            if (e.data.tablet) {
              tablet = ' d-md-block';
            }
            if (e.data.desktop) {
              desktop = ' d-lg-block';
            }
            tinymce.activeEditor.dom.addClass(ed.selection.getNode(), mobile + tablet + desktop);
          }
        });
      });
      ed.addCommand('h_do_twitter_quote', function (e) {
        var selected_node = ed.selection.getNode();
        var selected_text, returned;
        if (selected_node != 'blockquote') {
          selected_node = $(selected_node).parents('blockquote');
          selected_text = $(selected_node).text();
        } else {
          selected_node = selected_node;
        }

        if (selected_text.length > 100) {
          ed.windowManager.alert('Oops! This quote contains more than 100 characters.');
        } else {
          var permalink = $('#sample-permalink > a').attr('href');
          var sharelink = 'https://twitter.com/home?status=%22' + selected_text + '%22%20' + permalink;
          var where_my_cursor_at = ed.selection.getNode();
          var where_my_cursor_at_parent = tinymce.DOM.getParent(where_my_cursor_at, '.blockquote-inner');
          tinymce.activeEditor.dom.addClass(where_my_cursor_at_parent, 'tweet-this');
          var tweet_link = tinymce.activeEditor.dom.create('div', {
            'class': 'tweet-quote'
          }, '<a href="' + sharelink + '" target="_blank" title="Tweet This"><img src="/wp-content/themes/airstream-2018/assets/dist/images/Twitter_Logo_Blue.svg" alt="Tweet This"></a>');
          if ($(where_my_cursor_at).hasClass('quote')) {
            $(tweet_link).insertBefore(where_my_cursor_at);
          } else {
            var where_my_cursor_should_be = tinymce.DOM.getPrev(where_my_cursor_at, 'p');
            where_my_cursor_should_be.prepend(tweet_link);
          }
        }
      });
      ed.addCommand('h_do_quote', function () {
        var selected = ed.selection.getContent({ 'format': 'text' });
        var returned, quotee;
        ed.windowManager.open({
          title: 'Insert Block Quote',
          body: [{
            type: 'container',
            name: 'quote_container',
            label: 'Quote',
            layout: 'flex',
            direction: 'column',
            align: 'left',
            spacing: 10,
            items: [{
              type: 'container',
              name: 'quote_note',
              html: '<span style="color:#ff0000;font-size:11px;">Do NOT include quotation marks.</span>'
            }, {
              type: 'textbox',
              name: 'quote_text',
              value: selected,
              multiline: true,
              minWidth: 400,
              minHeight: 150,
              onchange: function onchange() {
                selected = this.value();
              }
            }]
          }, {
            type: 'textbox',
            label: 'Quotee',
            name: 'quotee',
            value: ''
          }, {
            type: 'listbox',
            label: 'Quotation Mark Color',
            name: 'quotation_mark_color',
            value: 'horizon',
            'values': [{
              text: 'Bloom',
              value: 'bloom'
            }, {
              text: 'Fire',
              value: 'fire'
            }, {
              text: 'Horizon',
              value: 'horizon'
            }]
          }],
          onSubmit: function onSubmit(e) {
            if (e.data.quotee.length > 0) {
              quotee = '<p class="quotee">- ' + e.data.quotee + '</p>';
            } else {
              quotee = '';
            }
            returned = '<blockquote><div class="blockquote-inner quote-mark-' + e.data.quotation_mark_color + '"><p class="quote">' + e.data.quote_text + ' </p>' + quotee + '</div></blockquote>';
            ed.execCommand('mceInsertContent', 0, returned);
          }
        });
      });
      ed.addCommand('h_do_link', function () {
        var selected = ed.selection.getContent({ 'format': 'html' });
        var hide_text, hide_img, link_text, link_type;
        if (selected.length === 0) {
          link_text = 'Click Here';
          link_type = 'Text';
          hide_text = 'block';
          hide_img = 'none';
        } else if (selected.length > 0 && selected.includes('img')) {
          var selected_img = ed.selection.getNode();
          var selected_img_src = selected_img.src;
          var selected_img_alt = selected_img.alt;
          link_text = '';
          link_type = 'Image';
          hide_text = 'none';
          hide_img = 'block';
        } else {
          link_text = selected;
          link_type = 'Text';
          hide_text = 'block';
          hide_img = 'none';
        }
        var data = {
          link_text: link_text,
          hide_text: hide_text,
          hide_img: hide_img,
          link_type: link_type,
          link_url: '#'
        };
        var returned = '';
        ed.windowManager.open({
          title: 'Insert Link',
          data: data,
          body: [{
            type: 'listbox',
            label: 'Link Content Type',
            name: 'link_content_type',
            value: data.link_type,
            'values': [{
              text: 'Text',
              value: 'Text'
            }, {
              text: 'Image',
              value: 'Image'
            }],
            onselect: function onselect() {
              if (this.value() == 'Text') {
                data.link_type = this.value();
                $('#link_text_field').css('display', 'block');
                $('#link_image_container').css('display', 'none');
                $('#link_image').css('display', 'none');
                $('#select_file_button').css('display', 'none');
              } else if (this.value() == 'Image') {
                data.link_type = this.value();
                $('#link_text_field').css('display', 'none');
                $('#link_image_container').css('display', 'block');
                $('#link_image').css('display', 'block');
                $('#select_file_button').css({ 'display': 'block', 'width': '84px', 'height': '28px' });
              } else {
                data.link_type = this.value();
                $('#link_text_field').css('display', 'block');
                $('#link_image_container').css('display', 'none');
                $('#link_image').css('display', 'none');
                $('#select_file_button').css('display', 'none');
              }
            }
          }, {
            type: 'textbox',
            name: 'link_text',
            id: 'link_text_field',
            value: data.link_text,
            style: 'display:' + data.hide_text,
            onchange: function onchange() {
              data.link_text = this.value();
            }
          }, {
            type: 'container',
            name: 'link_image_container',
            id: 'link_image_container',
            layout: 'flex',
            direction: 'row',
            align: 'left',
            spacing: 30,
            minHeight: 100,
            style: 'display:' + data.hide_img,
            items: [{
              type: 'container',
              name: 'link_image',
              id: 'link_image',
              html: '<div style="height:100px;width:100px;background-image:url(' + selected_img_src + ');background-position:center;background-size:cover;"></div>',
              minWidth: 110,
              style: 'display:' + data.hide_img
            }, {
              type: 'textbox',
              value: selected_img_src,
              name: 'link_image_src',
              id: 'link_image_src',
              minWidth: 1,
              hidden: true
            }, {
              type: 'textbox',
              value: selected_img_alt,
              name: 'link_image_alt',
              id: 'link_image_alt',
              hidden: true
            }, {
              type: 'button',
              name: 'select_file',
              text: 'Select File',
              id: 'select_file_button',
              style: 'display:' + data.hide_img,
              onclick: function onclick() {
                window.mb = window.mb || {};

                window.mb.frame = wp.media({ frame: 'post', state: 'insert', library: {
                    // type : 'file'
                  }, multiple: false });

                window.mb.frame.on('insert', function () {
                  var json = window.mb.frame.state().get('selection').first().toJSON();
                  $('#link_image').html('<div style="height:100px;width:100px;background-image:url(' + json.url + ');background-position:center;background-size:cover;"></div>');
                  $('#link_image_src').val(json.url);
                  $('#link_image_alt').val(json.alt);
                });

                window.mb.frame.open();
              }
            }]
          }, {
            name: 'link_title',
            label: 'Link Title',
            type: 'textbox',
            value: ''
          }, {
            name: 'link_url',
            label: 'URL',
            type: 'textbox',
            value: data.link_url,
            onchange: function onchange() {
              data.link_url = this.value();
            }
          }, {
            name: 'target',
            label: 'Target',
            type: 'listbox',
            'values': [{
              text: 'Same Page',
              value: '_self'
            }, {
              text: 'New Tab',
              value: '_blank'
            }]
          }],
          onSubmit: function onSubmit(e) {
            data = tinymce.extend(data, e.data);
            if (data.link_type == 'Text') {
              returned = '<a href="' + e.data.link_url + '" target="' + e.data.target + '" title="' + e.data.link_title + '">' + e.data.link_text + '</a>';
            }
            if (data.link_type == 'Image') {
              returned = '<a href="' + e.data.link_url + '" target="' + e.data.target + '" title="' + e.data.link_title + '"><img src="' + e.data.link_image_src + '" alt="' + e.data.link_image_alt + '"></a>';
            }
            ed.execCommand('mceReplaceContent', 0, returned);
          }
        });
      });
      ed.addCommand('h_do_download', function () {
        var selected = ed.selection.getContent({ 'format': 'html' });
        if (selected.length === 0) {
          selected = 'Click to Download Now';
        }
        var data = {
          link_text: selected,
          link_url: '#'
        };
        var returned = '';
        ed.windowManager.open({
          title: 'Insert Forced Download Link',
          data: data,
          body: [{
            name: 'link_text',
            label: 'Link Text',
            type: 'textbox',
            value: data.link_text,
            onchange: function onchange() {
              data.link_text = this.value();
            }
          }, {
            name: 'link_title',
            label: 'Link Title',
            type: 'textbox',
            value: ''
          }, {
            type: 'container',
            label: 'File Title',
            layout: 'flex',
            direction: 'column',
            align: 'left',
            // minWidth:300,
            items: [{
              type: 'container',
              name: 'file_title_note',
              html: '<span style="font-size:11px;">What the file will be named when downloaded. </span><br/> <span style="color:#ff0000;font-size:11px;">Do NOT include the file type.</span>'
            }, {
              name: 'file_title',
              type: 'textbox',
              value: 'Example-Title',
              minWidth: 300
            }]
          }, {
            type: 'container',
            label: 'File to Download',
            layout: 'flex',
            direction: 'column',
            align: 'left',
            spacing: 20,
            items: [{
              type: 'button',
              name: 'select_file',
              text: 'Select File',
              onclick: function onclick() {
                window.mb = window.mb || {};

                window.mb.frame = wp.media({ frame: 'post', state: 'insert', library: {
                    // type : 'file'
                  }, multiple: false });

                window.mb.frame.on('insert', function () {
                  var json = window.mb.frame.state().get('selection').first().toJSON();
                  $('#file_url').val(json.url);
                });

                window.mb.frame.open();
              }
            }, {
              type: 'textbox',
              name: 'file_url',
              label: 'File',
              id: 'file_url',
              value: '',
              minWidth: 300
            }]
          }],
          onSubmit: function onSubmit(e) {
            data = tinymce.extend(data, e.data);
            returned = '<a href="' + e.data.file_url + '" target="_blank" title="' + e.data.link_title + '" download="' + e.data.file_title + '">' + data.link_text + '</a>';
            ed.execCommand('mceInsertContent', 0, returned);
          }
        });
      });
      ed.addCommand('h_do_modal_image', function () {
        var selected = ed.selection.getContent({ 'format': 'html' });
        var link_type = 'text';
        var link_text = selected;
        var select_image = false;
        if (selected.length > 0 && selected.includes('img')) {
          link_type = 'image';
          link_text = '';
          select_image = true;
          var selected_img = ed.selection.getNode();
          var selected_img_src = selected_img.src;
          var selected_img_alt = selected_img.alt;
          var selected_img_title = selected_img.title;
          var large_img_link = selected_img_src.replace('-' + selected_img.width + 'x' + selected_img.height, '');
        }
        var data = {
          link_type: link_type,
          link_text: link_text,
          select_image: select_image
        };
        var returned = '';

        ed.windowManager.open({
          title: 'Insert Modal Image',
          data: data,
          body: [{
            type: 'container',
            label: 'Modal Image',
            name: 'link_image_container',
            id: 'link_image_container',
            layout: 'flow',
            minWidth: 300,
            minHeight: 150,
            spacing: 10,
            style: 'display:block',
            items: [{
              type: 'container',
              name: 'link_image',
              id: 'link_image',
              html: '<div style="height:100px;width:100px;background-image:url(' + selected_img_src + ');background-position:center;background-size:cover;"></div>',
              style: {
                'width': '100px',
                'border': '1px solid #eee',
                'margin-right': '10px'
              }
            }, {
              type: 'button',
              name: 'select_image',
              text: 'Select Image',
              id: 'select_image_button',
              style: 'width:100px!important',
              minWidth: 100,
              disabled: data.select_image,
              onclick: function onclick() {
                window.mb = window.mb || {};

                window.mb.frame = wp.media({
                  frame: 'post',
                  state: 'insert',
                  library: {
                    type: 'image'
                  },
                  multiple: false
                });

                window.mb.frame.on('insert', function () {
                  var json = window.mb.frame.state().get('selection').first().toJSON();
                  $('#link_image').html('<div style="height:100px;width:100px;background-image:url(' + json.url + ');background-position:center;background-size:cover;"></div>');
                  $('#link_image_src').val(json.url);
                  $('#link_image_alt').val(json.alt);
                  $('#large_img_link').val(json.sizes.full.url);
                  $('#image_title').val(json.title);
                });

                window.mb.frame.open();
              }
            }, {
              type: 'textbox',
              value: selected_img_src,
              name: 'link_image_src',
              id: 'link_image_src',
              style: 'width:300px',
              minWidth: 200,
              disabled: true
            }, {
              type: 'textbox',
              value: selected_img_alt,
              name: 'link_image_alt',
              id: 'link_image_alt',
              hidden: true
            }, {
              type: 'textbox',
              value: large_img_link,
              name: 'large_img_link',
              id: 'large_img_link',
              hidden: true
            }]
          }, {
            type: 'textbox',
            value: selected_img_title,
            label: 'Image Title',
            name: 'image_title',
            id: 'image_title',
            style: 'width:300px'
          }],
          onSubmit: function onSubmit(e) {
            var where_my_cursor_at = ed.selection.getNode(),
                node_name = where_my_cursor_at.nodeName.toLowerCase(),
                selected_node;
            if (data.selected != '') {
              if (node_name == 'p') {
                var title;
                if (e.data.image_title !== '') {
                  title = ' title="' + e.data.image_title + '"';
                }
                returned = '<a class="popup-image-link" href="' + e.data.large_img_link + '"' + title + '>' + data.link_text + '</a>';
                ed.execCommand('mceInsertContent', 0, returned);
              } else {
                ed.execCommand('mceInsertLink', 0, e.data.large_img_link);
                if (node_name == 'img') {
                  selected_node = tinymce.DOM.getParent(where_my_cursor_at, 'a');
                  tinymce.activeEditor.dom.setAttribs(selected_node, { 'href': e.data.large_img_link, 'class': 'popup-image-link popup-link-with-image', 'title': e.data.image_title });
                } else {
                  selected_node = where_my_cursor_at;
                  tinymce.activeEditor.dom.setAttribs(selected_node, { 'href': e.data.large_img_link, 'class': 'popup-image-link', 'title': e.data.image_title });
                }
              }
            } else {
              ed.execCommand('mceInsertLink', 0, e.data.large_img_link);
              selected_node = ed.selection.getNode();
              console.log(selected_node);
              tinymce.activeEditor.dom.setAttribs(selected_node, { 'class': 'popup-image-link', 'title': e.data.image_title });
            }
          }
        });
      });
      ed.addCommand('h_do_modal_video', function () {
        var selected = ed.selection.getContent({ 'format': 'html' });
        var link_type = 'text';
        var link_text = selected;
        if (selected.length > 0 && selected.includes('img')) {
          link_type = 'image';
          link_text = '';
          var selected_img = ed.selection.getNode();
          var selected_img_src = selected_img.src;
          var selected_img_alt = selected_img.alt;
        }
        var data = {
          link_type: link_type,
          link_text: link_text,
          selected: selected
        };
        var returned = '';

        ed.windowManager.open({
          title: 'Insert Modal Video',
          data: data,
          body: [{
            type: 'container',
            label: 'Video URL',
            layout: 'flex',
            direction: 'column',
            align: 'left',
            items: [{
              type: 'container',
              name: 'video_url_note',
              html: '<span style="font-size:11px;">Video can be YouTube, Wistia, Vimeo, or Brightcove.</span><br/><span style="color:#ff0000;font-size:11px;">Copy URL from address bar and paste here.</span>'
            }, {
              type: 'textbox',
              name: 'video_url',
              value: '',
              minWidth: 300
            }]
          }, {
            type: 'textbox',
            label: 'Video Title',
            name: 'video_title',
            value: '',
            style: 'width:300px'
          }],
          onSubmit: function onSubmit(e) {
            // data = tinymce.extend(data, e.data);
            var where_my_cursor_at = ed.selection.getNode(),
                node_name = where_my_cursor_at.nodeName.toLowerCase(),
                selected_node;
            if (data.selected != '') {
              if (node_name == 'p') {
                var title;
                if (e.data.video_title !== '') {
                  title = ' title="' + e.data.video_title + '"';
                }
                returned = '<a class="popup-iframe-link" href="' + e.data.video_url + '"' + title + '>' + data.link_text + '</a>';
                ed.execCommand('mceInsertContent', 0, returned);
              } else {
                ed.execCommand('mceInsertLink', 0, e.data.video_url);
                if (node_name == 'img') {
                  selected_node = tinymce.DOM.getParent(where_my_cursor_at, 'a');
                  tinymce.activeEditor.dom.setAttribs(selected_node, { 'href': e.data.video_url, 'class': 'popup-iframe-link popup-link-with-image', 'title': e.data.video_title });
                } else {
                  selected_node = where_my_cursor_at;
                  tinymce.activeEditor.dom.setAttribs(selected_node, { 'href': e.data.video_url, 'class': 'popup-iframe-link', 'title': e.data.video_title });
                }
              }
            } else {
              ed.execCommand('mceInsertLink', 0, e.data.video_url);
              selected_node = ed.selection.getNode();
              console.log(selected_node);
              tinymce.activeEditor.dom.setAttribs(selected_node, { 'class': 'popup-iframe-link', 'title': e.data.video_title });
            }
          }
        });
      });
      ed.addCommand('h_do_columns', function () {
        var split, stack_order, breakpoint, divider, leftClass, rightClass;
        // var data = {
        //   split: split,
        //   stack_order: stack_order,
        //   breakpoint: breakpoint,
        //   divider: divider,
        // }
        var returned = '';
        ed.windowManager.open({
          title: 'Insert Two Column Structure',
          body: [{
            type: 'listbox',
            label: 'Column Split',
            name: 'column_split',
            // value: data.split,
            'values': [{
              text: '50/50',
              value: 'half'
            }, {
              text: '25/75',
              value: 'quarter_left25'
            }, {
              text: '75/25',
              value: 'quarter_right25'
            }, {
              text: '33/66',
              value: 'third_left33'
            }, {
              text: '66/33',
              value: 'third_right33'
            }, {
              text: '40/60',
              value: 'fifths_left40'
            }, {
              text: '60/40',
              value: 'fifths_right40'
            }]
            // onselect: function() {
            //   if( this.value() == 'quarter_left25' ) {
            //     leftClass = 'col-md-3';
            //     rightClass = 'col-md-9';
            //   }
            //   // data.split = this.value();
            // },
          }, {
            type: 'container',
            label: 'Column Stack Breakpoint',
            layout: 'flex',
            direction: 'column',
            align: 'left',
            minWidth: 300,
            items: [{
              type: 'container',
              name: 'column_stack_breakpoint_note',
              html: '<span style="font-size:11px;">This is the point at which the two columns stack into a single column.</span>'
            }, {
              name: 'column_stack_breakpoint',
              type: 'listbox',
              'values': [{
                text: 'Extra Small Devices (phones, less than 768px)',
                value: 'xs'
              }, {
                text: 'Small Devices (tablets, 768px and up)',
                value: 'sm'
              }, {
                text: 'Medium Devices (desktops, 992px and up)',
                value: 'md'
              }, {
                text: 'Large Devices (large desktops, 1200px and up)',
                value: 'lg'
              }]
            }]
          }, {
            type: 'container',
            label: 'Column Stack Order',
            layout: 'flex',
            direction: 'column',
            align: 'left',
            // minWidth:300,
            items: [{
              type: 'container',
              name: 'column_stack_order_note',
              html: '<span style="font-size:11px;">By default, the right column will stack <span style="font-size:11px;font-weight:bold;">under</span> the left column.</span>'
            }, {
              name: 'column_stack_order',
              type: 'checkbox',
              text: 'Stack right column above left column',
              checked: false
            }]
          }, {
            type: 'checkbox',
            label: 'Column Divider',
            name: 'column_divider',
            text: 'Include divider between columns',
            checked: true
          }],
          onSubmit: function onSubmit(e) {
            // data = tinymce.extend(data, e.data);
            // alert(e.data.column_split)
            if (e.data.column_split == 'quarter_left25') {
              leftClass = 'col-sm-3';
              rightClass = 'col-sm-9';
            }
            returned = '<div class="row"><div class="' + leftClass + '">Left Column</div><div class="' + rightClass + '">Right Column</div></div>';
            ed.execCommand('mceInsertContent', 0, returned);
          }
        });
      });
      ed.addCommand('air_do_share', function () {
        var selected_node = ed.selection.getNode();
        ed.windowManager.open({
          title: 'Social Sharing',
          body: [{
            type: 'container',
            name: 'share_note',
            html: '<span style="font-size:14px;">Add share icons for Facebook, Twitter, and Pinterest.</span>'
          }, {
            type: 'textbox',
            name: 'share_heading',
            label: 'Heading'
          }, {
            type: 'textbox',
            name: 'share_link',
            label: 'Link to Share'
          }, {
            type: 'textbox',
            name: 'description',
            label: 'Description',
            multiline: true,
            minWidth: 400,
            minHeight: 150
          }, {
            type: 'container',
            label: 'Image',
            name: 'image_container',
            id: 'image_container',
            layout: 'flow',
            minWidth: 300,
            minHeight: 150,
            spacing: 10,
            style: 'display:block',
            items: [{
              type: 'container',
              name: 'image',
              id: 'image',
              html: '<div style="height:100px;width:100px;background-image:url();background-position:center;background-size:cover;"></div>',
              style: {
                'width': '100px',
                'border': '1px solid #eee',
                'margin-right': '10px'
              }
            }, {
              type: 'button',
              name: 'select_image',
              text: 'Select Image',
              id: 'select_image_button',
              style: 'width:100px!important',
              minWidth: 100,
              // disabled: data.select_image,
              onclick: function onclick() {
                window.mb = window.mb || {};

                window.mb.frame = wp.media({
                  frame: 'post',
                  state: 'insert',
                  library: {
                    type: 'image'
                  },
                  multiple: false
                });

                window.mb.frame.on('insert', function () {
                  var json = window.mb.frame.state().get('selection').first().toJSON();
                  $('#image').html('<div style="height:100px;width:100px;background-image:url(' + json.url + ');background-position:center;background-size:cover;"></div>');
                  $('#image_src').val(json.url);
                });

                window.mb.frame.open();
              }
            }, {
              type: 'textbox',
              name: 'image_src',
              id: 'image_src',
              style: 'width:300px',
              minWidth: 200,
              disabled: true
            }]
          }],
          onSubmit: function onSubmit(e) {
            ed.execCommand('mceInsertContent', 0, '[social_share heading="' + e.data.share_heading + '" link="' + e.data.share_link + '" description="' + e.data.description + '" image="' + e.data.image_src + '"]');
          }
        });
      });
    },
    /**
     * Creates control instances based in the incomming name. This method is normally not
     * needed since the addButton method of the tinymce.Editor class is a more easy way of adding buttons
     * but you sometimes need to create more complex controls like listboxes, split buttons etc then this
     * method can be used to create those.
     *
     * @param {String} n Name of the control to create.
     * @param {tinymce.ControlManager} cm Control manager to use inorder to create new control.
     * @return {tinymce.ui.Control} New control instance or null if no control was created.
     */
    createControl: function createControl(n, cm) {
      return null;
    },

    /**
     * Returns information about the plugin as a name/value array.
     * The current keys are longname, author, authorurl, infourl and version.
     *
     * @return {Object} Name/value array containing information about the plugin.
     */
    getInfo: function getInfo() {
      return { longname: 'Helium Custom TinyMCE Buttons', author: 'Dina Minkow for Element Three', authorurl: 'http://elementthree.com', infourl: '', version: '0.1' };
    }
  });

  // Register plugin
  tinymce.PluginManager.add('h_buttons', tinymce.plugins.AirstreamButtons);
})(jQuery);

},{}]},{},[1]);
